import { ColumnDef } from "@tanstack/react-table";
import { PriceCell, ProductCell } from "modules/products";
import { ProductsSharingsListItem, SocialIcon } from "modules/sharing";
import moment from "moment";
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { ItemsTable } from "ui";

import { ResellerProductsSharingsTableProps } from "./ResellerProductsSharingsTable.types";

import styles from "./ResellerProductsSharingsTable.module.scss";

const ResellerProductsSharingsTable = ({
  items,
  sorting,
  setSorting,
  isLoading
}: ResellerProductsSharingsTableProps) => {
  const columns: Array<
    ColumnDef<ProductsSharingsListItem, ProductsSharingsListItem[]>
  > = useMemo(
    () => [
      {
        header: "Shared Product",
        size: 50,
        minSize: 50,
        cell: ({ row }) => (
          <ProductCell
            name={items[row.index].variant.name}
            image={items[row.index].variant.image}
            subtitle={items[row.index].variant.categoryName}
          />
        )
      },
      {
        id: "DiscountedPrice",
        accessorKey: "DiscountedPrice",
        header: "Standard Price",
        size: 25,
        minSize: 25,
        cell: ({ row }) => (
          <PriceCell
            price={items[row.index].variant.standardPrice}
            discountedPrice={items[row.index].variant.discountedPrice}
          />
        )
      },
      {
        header: "Social",
        size: 25,
        minSize: 25,
        cell: ({ row }) => (
          <div className={styles.resellerProductsSharingsTable_socialMedia}>
            <SocialIcon social={items[row.index].socialMedia} />
            {items[row.index].socialMedia ?? "Other"}
          </div>
        )
      },
      {
        id: "CreatedAt",
        accessorKey: "CreatedAt",
        header: "Share date",
        size: 15,
        minSize: 15,
        cell: ({ row }) => (
          <pre>
            {`${moment(items[row.index].createdAt).format("DD/MM/YYYY")}`}
            {"\n"}
            {`${moment(items[row.index].createdAt).format("HH:mm")}`}
          </pre>
        )
      }
    ],
    [items, sorting]
  );

  return (
    <>
      <ItemsTable
        className={styles.resellerProductsSharingsTable}
        columns={columns}
        data={items}
        sorting={sorting}
        setSorting={setSorting}
        isLoading={isLoading}
        skeletonHeight={65}
      />
    </>
  );
};

export default ResellerProductsSharingsTable;
